import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Travel from "@/components/Travel";
import ArticlesPreview from "@/components/ArticlesPreview";
import ChallengesTeaser from "@/components/ChallengesTeaser";
import Founders from "@/components/Founders";
import Enquiry from "@/components/Enquiry";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <>
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Travel />
        <ArticlesPreview />
        <ChallengesTeaser />
        <Founders />
        <Enquiry />
      </main>
      <Footer />
    </>
  );
}
